import { useEffect } from 'react';
import debounce from 'lodash.debounce';
import { useDispatch } from 'react-redux';

import { setDimensions } from '../../reducers';
import { computeSizes } from './computeSizes';

const DEBOUNCE_DELAY = 200;

const getDimensions = ({ innerWidth, innerHeight }) => ({
  innerWidth,
  innerHeight,
});

export const useDimensions = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const onResize = () => dispatch(setDimensions(computeSizes(getDimensions(window))));
    const onChange = debounce(onResize, DEBOUNCE_DELAY);

    onChange();

    window.addEventListener('resize', onChange, false);
    window.addEventListener('orientationchange', onChange, false);

    return () => {
      window.removeEventListener('resize', onChange, false);
      window.removeEventListener('orientationchange', onChange, false);
    };
  }, [dispatch]);
};